<div class="detail-dialog">

  <div class="dialog-header" [ngClass]="statusClass">
    <div class="header-main">
      <mat-icon class="header-icon">{{ headerIcon }}</mat-icon>
      <div class="header-text">
        <h2 class="header-filename">{{ dataset.name || 'Sin nombre' }}</h2>
        <div class="header-meta">
          <span class="header-type">{{ dataset.file_type.toUpperCase() || 'FILE' }}</span>
          <span class="header-status-badge">{{ statusLabel }}</span>
        </div>
      </div>
    </div>
    <button mat-icon-button class="close-btn" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">

    <div class="timeline-section">
      @for (step of steps; track step.label; let i = $index) {
        <div class="step-item">
          <div class="step-circle" [attr.data-state]="stepState(i)">
            @if (stepState(i) === 'done') {
              <mat-icon>check</mat-icon>
            } @else if (stepState(i) === 'error') {
              <mat-icon>close</mat-icon>
            } @else {
              <mat-icon>{{ step.icon }}</mat-icon>
            }
          </div>
          <span class="step-label" [attr.data-state]="stepState(i)">{{ step.label }}</span>
        </div>
        @if (i < steps.length - 1) {
          <div class="step-connector" [class.connector-filled]="stepState(i) === 'done'"></div>
        }
      }
    </div>

    @if (isDone) {
      <div class="result-banner banner-success">
        <mat-icon>check_circle_outline</mat-icon>
        <div class="banner-content">
          <p class="banner-description">La importación se completó correctamente y los datos ya están disponibles.</p>

          @if (hasDeletedRows) {
            <div class="replace-summary">
              <div class="replace-stat is-deleted">
                <span class="replace-stat-icon"><mat-icon>delete_sweep</mat-icon></span>
                <span class="replace-stat-text">
                  <strong>{{ deletedRowsFormatted }}</strong>
                  <small>filas eliminadas</small>
                </span>
              </div>
              <mat-icon class="replace-arrow">arrow_forward</mat-icon>
              <div class="replace-stat is-loaded">
                <span class="replace-stat-icon"><mat-icon>upload_file</mat-icon></span>
                <span class="replace-stat-text">
                  <strong>{{ loadedRowsFormatted }}</strong>
                  <small>filas cargadas</small>
                </span>
              </div>
            </div>

            @if (scopeFilterLabel) {
              <p class="scope-line">
                <mat-icon>filter_alt</mat-icon>
                Se eliminaron las filas donde <code>{{ scopeFilterLabel }}</code>
              </p>
            } @else if (dataset.type === 'full_replace') {
              <p class="scope-line">
                <mat-icon>filter_alt</mat-icon>
                Se reemplazó todo el contenido del dataset.
              </p>
            }
          } @else if (successRowsLabel) {
            <div class="rows-summary">
              <span class="rows-chip rows-loaded">
                <mat-icon>table_rows</mat-icon>{{ successRowsLabel }}
              </span>
            </div>
          }
        </div>
      </div>
    }

    @if (isFailed) {
      <div class="result-banner banner-error">
        <mat-icon>error_outline</mat-icon>
        <div class="banner-content">
          <p class="banner-description">{{ errorHeadline }}</p>

          @if (parsedError && parsedError.missing.length) {
            <div class="err-fields">
              <span class="err-fields-label is-missing">Faltan en tu archivo ({{ parsedError.missing.length }})</span>
              <div class="err-chips">
                @for (field of visibleMissing; track field) {
                  <span class="err-chip chip-missing">{{ field }}</span>
                }
                @if (parsedError.missing.length > missingPreviewCount) {
                  <button type="button" class="err-more" (click)="showAllMissing = !showAllMissing">
                    {{ showAllMissing ? 'Ver menos' : '+' + (parsedError.missing.length - missingPreviewCount) + ' más' }}
                  </button>
                }
              </div>
            </div>
          }

          @if (parsedError && parsedError.extras.length) {
            <div class="err-fields">
              <span class="err-fields-label is-extra">Columnas de más ({{ parsedError.extras.length }})</span>
              <div class="err-chips">
                @for (field of parsedError.extras; track field) {
                  <span class="err-chip chip-extra">{{ field }}</span>
                }
              </div>
            </div>
          }

          @if (parsedError && parsedError.detected.length) {
            <div class="err-fields">
              <span class="err-fields-label is-detected">Encabezados detectados ({{ parsedError.detected.length }})</span>
              <div class="err-chips">
                @for (field of parsedError.detected; track field) {
                  <span class="err-chip chip-detected">{{ field }}</span>
                }
              </div>
            </div>
          }

          @if (dataset.validation_code || dataset.error_code) {
            <code class="error-code-chip">{{ dataset.validation_code || dataset.error_code }}</code>
          }

          @if (parsedError && parsedError.raw) {
            <details class="banner-raw">
              <summary>Ver mensaje completo</summary>
              <p>{{ parsedError.raw }}</p>
            </details>
          }
        </div>
      </div>
    }

    <div class="details-section">
      <p class="section-label">Detalle de la carga</p>
      <div class="details-grid">
        <div class="detail-row">
          <span>Schema</span>
          <strong>{{ dataset.schema || '-' }}</strong>
        </div>
        <div class="detail-row">
          <span>Tipo de operación</span>
          <strong>{{ operationLabel(dataset.type) }}</strong>
        </div>
        <div class="detail-row">
          <span>Enviado por</span>
          <strong>{{ senderDisplay }}</strong>
        </div>
        <div class="detail-row">
          <span>Fecha de envío</span>
          <strong>{{ formatDate(dataset.created_at) }}</strong>
        </div>
        @if (dataset.updated_at) {
          <div class="detail-row">
            <span>Última actualización</span>
            <strong>{{ formatDate(dataset.updated_at) }}</strong>
          </div>
        }
        <div class="detail-row detail-row-id">
          <span>ID de carga</span>
          <code class="detail-id">{{ dataset.id }}</code>
        </div>
      </div>
    </div>

  </div>

  <div class="dialog-footer">
    <button mat-flat-button color="primary" (click)="dialogRef.close()">Cerrar</button>
  </div>

</div>
